"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.heading2Config = exports.createHeading2Node = void 0;
var react_1 = __importDefault(require("react"));
var slate_1 = require("slate");
var MakeConfig_1 = require("../Utils/MakeConfig");
var GetCommonConfigByType_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetCommonConfigByType");
var EditorPlaceholder_1 = __importDefault(require("Project/QwilrEditor/Placeholder/EditorPlaceholder"));
var EditorWidgetRegistry_1 = require("../EditorWidgetRegistry");
var TokenModels_1 = __importDefault(require("@CommonFrontend/ContentTokens/TokenModels"));
var WidgetActions_1 = require("Project/QwilrEditor/Behaviours/WidgetActions");
var Models_1 = require("@CommonFrontend/ContentTokens/Models");
var Text_1 = require("@CommonFrontend/ContentTokens/DataModels/Text");
var Serialise_1 = require("Project/QwilrEditor/Tokenization/Serialise");
var EditorWidgetRegistry_2 = require("../EditorWidgetRegistry");
var classnames_1 = __importDefault(require("classnames"));
var Heading2_css_1 = require("ContentTokens/SharedWidgetComponents/Text/Heading2.css");
var StylesContext_1 = require("Project/QwilrEditor/StylesContext");
var textStyles_1 = require("@CommonFrontend/WidgetRegistry/Traits/Styleable/textStyles");
var createHeading2Node = function () { return ({
    type: "heading2",
    children: [Text_1.text.createSlateJson()],
    isVoid: false,
}); };
exports.createHeading2Node = createHeading2Node;
var Heading2Widget = function (_a) {
    var element = _a.element, attributes = _a.attributes, children = _a.children, style = _a.style;
    var computeForegroundColor = (0, StylesContext_1.useStylesContext)().computeForegroundColor;
    return (react_1.default.createElement("h2", __assign({}, attributes, { className: (0, classnames_1.default)(attributes.className, Heading2_css_1.h2Widget), style: __assign(__assign({}, attributes.style), (0, textStyles_1.maybeAssignComputedForegroundColor)({
            computeForegroundColor: computeForegroundColor,
            foregroundColorVar: Heading2_css_1.vars.color,
            foregroundStyle: style,
        })) }),
        react_1.default.createElement(EditorPlaceholder_1.default, { element: element }),
        children));
};
exports.heading2Config = (0, MakeConfig_1.makeConfig)(__assign(__assign({}, (0, GetCommonConfigByType_1.getCommonConfigByType)("heading2")), { editorRender: Heading2Widget, node: {}, nodeType: "textElement", serialise: function (node, editor, commentTracker, selection) { return __spreadArray([
        { subType: "heading2", type: "block" }
    ], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false); }, deserialise: function () { return ({
        type: "heading2",
        data: {},
        children: [],
        isVoid: false,
    }); }, normalizeWidget: function (node, path, editor) {
        var _a;
        var config = (0, EditorWidgetRegistry_1.getConfigByType)(node.type);
        for (var i = 0; i < node.children.length; i++) {
            var currChild = node.children[i];
            if (slate_1.Text.isText(currChild)) {
                continue;
            }
            var childConfig = (0, EditorWidgetRegistry_2.getGenericConfigByType)(currChild.type);
            if (childConfig
                ? !childConfig.validContainers.includes(node.type)
                : ((_a = config.textNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) &&
                    !config.textNodeConfiguration.validChildren.includes(currChild.type)) {
                slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                return true;
            }
        }
        if (node.children.length === 0) {
            slate_1.Transforms.insertNodes(editor, TokenModels_1.default.text.createSlateJson(""), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        return false;
    }, width: "full-width", validEditors: ["standard", "agreement", "quotePlanCard", "quote"], validContainers: [
        "accordionHeading",
        "accordionBody",
        "contentLoopBody",
        "sideBySideColumn",
        "tableCell",
        "boxColumn",
        "layoutColumn",
    ], firstLastConfiguration: {
        isValidFirstChild: true,
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: (0, exports.createHeading2Node)(),
        });
    }, textNodeConfiguration: {
        validChildren: [Models_1.InlineType.Link, Models_1.InlineType.LineBreak, Models_1.InlineType.Variable, Models_1.InlineType.TokenWidget],
    } }));
